const address = {
    list: {},
};
const AddressReducer = function(state = address, action) {
    switch (action.type) {
        case 'UPDATE_ADDRESS_LIST': {
            return {
                ...state,
                list: {
                    ...state.list,
                    ...action.list,
                },
            };
        }
        default: {
            return state;
        }
    }
};

export default AddressReducer;
